export default "__VITE_ASSET__BAl_0n1E__"